/**
 * Created by esenckewitch on 2026-05-21
 *
 * https://arkadiumsdk.z19.web.core.windows.net/docs/features/analytics
 */

const ArkadiumLogger = function () {
    this.config = {
        lifetime: "365 days"
    };

    this.dimensions = {};

    connector.platform.whenConnected(() => this.connect());
};

ArkadiumLogger.isApplicable = function () {
    return connector.platform.oneOf(connector.ARKADIUM);
};

ArkadiumLogger.prototype.connect = function () {
    const analytics = typeof ArkadiumSDK !== "undefined" && ArkadiumSDK.analytics;
    if (!analytics || typeof analytics.configureProvider !== "function") {
        return;
    }

    const config = connector.config.arkadium || {};
    const setups = [];

    if (connector.config.debugMode) {
        setups.push(Promise.resolve(analytics.configureProvider({
            provider: analytics.CONSOLE,
            appId: config.appId || "console"
        })).catch((e) => console.warn("ArkadiumLogger.configureProvider(CONSOLE) failed", e)));
    }

    if (config.appId) {
        setups.push(Promise.resolve(analytics.configureProvider({
            provider: analytics.APP_INSIGHTS,
            appId: config.appId
        })).catch((e) => console.warn("ArkadiumLogger.configureProvider(APP_INSIGHTS) failed", e)));
    } else {
        console.warn("ArkadiumLogger: appId is not configured (connector.config.arkadium.appId)");
    }

    Promise.all(setups).then(() => this.onConnected());
};

ArkadiumLogger.prototype.onConnected = function () {
    this.ready = true;

    connector.platform.on("gameReady", () => {
        this.callMethod("sendMainScreenReadyEvent");
        this.callMethod("sendIntroScreenPageView");
    });

    connector.platform.on("levelStart", (levelNo) => {
        this.callMethod("sendGameplayReadyEvent");
        this.callMethod("sendGameScreenPageView");
        this.callMethod("sendRoundEvent", { round: levelNo });
    });
    connector.platform.on("levelEnd", (levelNo) => {
        this.callMethod("sendRoundEndEvent", "Finished", { round: levelNo });
    });

    this.callMethod("sendAppStartedEvent");
};

ArkadiumLogger.prototype.setDimensions = function (dimensions) {
    Object.assign(this.dimensions, dimensions || {});
    this.callMethod("setDimensions", this.dimensions);
};

ArkadiumLogger.prototype.trackEvent = function (name, params = {}) {
    this.callMethod("sendEvent", "cleverapps", name, params);
};

ArkadiumLogger.prototype.trackException = function (error) {
    if (error) {
        this.callMethod("sendErrorEvent", { reason: error.message || String(error) });
    }
    this.callMethod("trackException", error);
};

ArkadiumLogger.prototype.callMethod = function (method, ...args) {
    if (!this.ready || typeof ArkadiumSDK.analytics[method] !== "function") {
        return undefined;
    }

    try {
        return ArkadiumSDK.analytics[method](...args);
    } catch (e) {
        console.warn(`ArkadiumLogger.${method} failed`, e);
    }
};